<template>
    <div>
        <el-container v-if="jyjlList.length>0">
                <!-- <el-header>保证金交易明细</el-header> -->
                <el-main class="baozhengjin">
                    <template v-for="(item, index) in jyjlList" >
                        <el-row v-if="index!=0">
                            <el-divider class="horizontal"></el-divider>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <div class="grid-content bg-nocolor">
                                <span>
                                    保证金收款账号：{{ item.subAccNo }}
                                </span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="grid-content bg-nocolor">
                                <span>
                                    交易金额：{{ item.TRANAMT }}
                                </span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="grid-content bg-nocolor">
                                <span>
                                    交易时间：{{ item.TIMEFORMATED }}
                                </span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <div class="grid-content bg-nocolor">
                                <span>
                                    打款账号：{{ item.OPPACCNO }}
                                </span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="grid-content bg-nocolor">
                                <span>
                                    打款账户名：{{ item.OPPACCNAME }}
                                </span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="grid-content bg-nocolor">
                                <span>
                                    打款开户行：{{ item.OPPBRANCHNAME }}
                                </span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="grid-content bg-nocolor">
                                <span>
                                    交易说明：{{ item.RESUME }}
                                </span>
                                </div>
                            </el-col>
                        </el-row>
                    </template>
                </el-main>
            </el-container>
    <!-- <my-form-item-group title="虚拟账户交易明细" >
        <template  v-for="(item,index) in form.itemlist"  class="bdxx">
            <el-form-item label="保证金账号"  class="bd"  :prop="`itemlist.${index}.bdname`">
                {{item.bdname}}
            </el-form-item>
            <el-form-item label="对方账号" prop="zbdwname" >
                {{item.planys}}
            </el-form-item>
            <el-form-item label="交易金额" prop="zbdwname">
                {{item.zbdwname}}
            </el-form-item>
            <el-form-item label="对方账户名"  :prop="`itemlist.${index}.zbdwregion`">
                {{item.zbdwregion}}
            </el-form-item>
            <el-form-item label="交易时间"  :prop="`itemlist.${index}.zbjg`">
               {{item.zbjg}}
            </el-form-item> 
            <el-form-item label="对方开户行"  :prop="`itemlist.${index}.zbdwnature`" >
                {{item.zbjg}}
            </el-form-item>
            <el-form-item label="交易说明" class="table-full-row" :prop="`itemlist.${index}.resultcontent`" >
                {{item.resultcontent}}
            </el-form-item>
        </template>
        </my-form-item-group >  -->
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'
export default {
    mixins: [ FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    props: {
        data: {
            type: String,
            default: ''
        }
    },
    components: {},
    data() {
        return{
            jyjlList:[]
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
       
    },
    created() {
        this.$post(`${this.getGetters('bidUrl')}/TouBiao/Bzj/jymxbzjlcode.json`, {
            jlcode:this.data
        }, (data, res) => {
            this.jyjlList=data.jyjlList
            // this.reloadHandler();
        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
.baozhengjin {
    height: 500px;
    overflow: auto
}
</style>
